var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BadgeBase',{attrs:{"size":_vm.size,"text":"PayMe","borderColorClass":"pay-me","textColorClass":"pay-me-text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }